import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import Button from './Button';
import { useAuth } from '../../contexts/AuthContext';

const navClass = ({ isActive }: { isActive: boolean }) =>
    `px-3 py-2 rounded-md text-sm font-medium ${isActive ? 'bg-blue-50 text-blue-700' : 'text-gray-600 hover:bg-gray-100'}`;

const AppLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const { user, logout } = useAuth();
    const navigate = useNavigate();

    return (
        <div className="min-h-screen bg-gray-50">
            <header className="bg-white border-b border-gray-200">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
                    <div className="flex items-center gap-6">
                        <button
                            className="flex items-center gap-3 text-xl font-bold text-gray-900"
                            onClick={() => navigate('/dashboard')}
                        >
                            <img src="/logo-brand.png" alt="Hermes" className="h-10 w-auto object-contain" />
                        </button>
                        <nav className="hidden md:flex items-center gap-1">
                            <NavLink to="/dashboard" className={navClass}>Dashboard</NavLink>
                            <NavLink to="/campaigns" className={navClass}>Campaigns</NavLink>
                            {user?.role === 'admin' && <NavLink to="/admin" className={navClass}>Admin</NavLink>}
                        </nav>
                    </div>
                    <div className="flex items-center gap-4">
                        <div className="hidden sm:block text-right">
                            <p className="text-sm font-medium text-gray-900">{user?.full_name}</p>
                            <p className="text-xs text-gray-500 uppercase">{user?.role}</p>
                        </div>
                        <Button variant="outline" size="sm" onClick={logout}>Sign out</Button>
                    </div>
                </div>
            </header>
            {children}
        </div>
    );
};

export default AppLayout;
